import Image from 'next/image'
import type { FC } from 'react'
import heroHomePage from '../../../../public/assets/Hero_HomePage.png'

const MLHomePageHeroImage: FC = () => (
  <>
    <div className="relative w-full aspect-[1.2]">
      <Image
        data-testid="ml-home-page-hero-mobile"
        src={heroHomePage}
        alt="Mission Lane Visa Green and Silver Line credit cards with mobile phone showing account details"
        sizes="100vw"
        quality={100}
        priority
        fill
      />
    </div>
  </>
)

export default MLHomePageHeroImage
